import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content px-3" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "fw-bolder mb-1 text-black" }
const _hoisted_6 = { class: "fw-bold text-muted text-hover-primary fs-7 mb-1" }
const _hoisted_7 = { class: "d-flex mb-1" }
const _hoisted_8 = { class: "fs-8 text-muted me-1" }
const _hoisted_9 = { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 border border-success" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = { class: "menu-item px-5 my-1" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_14 = { class: "menu-link px-5" }
const _hoisted_15 = { class: "menu-title position-relative" }
const _hoisted_16 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "symbol symbol-20px me-4" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_23 = { class: "menu-item px-5 my-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-power fs-1 me-3 text-white" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.username?.firstname) + " " + _toDisplayString(_ctx.username?.lastname), 1),
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.username?.email1), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t("profile")), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.username?.profile), 1)
          ])
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("a", {
        href: _ctx.terms,
        target: "_blank",
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.t("terms")), 9, _hoisted_12)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _createTextVNode(" Language "),
          _createElementVNode("span", _hoisted_16, [
            _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: '/' + _ctx.currentLangugeLocale.flag,
              alt: "metronic"
            }, null, 8, _hoisted_17)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu-item px-3",
            key: 'ctr-' + index
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.setLang(item.id)),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(item.id) }])
            }, [
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("img", {
                  class: "rounded-1",
                  src: '/' + item.flag,
                  alt: "metronic"
                }, null, 8, _hoisted_21)
              ]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 10, _hoisted_19)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "d-block px-5 btn btn-sm btn-danger"
      }, [
        _hoisted_24,
        _createTextVNode(" " + _toDisplayString(_ctx.t("signOut")), 1)
      ])
    ])
  ]))
}